/* globals $ */
module.exports = (function () {

    function FormsetManager(form, options) {

        this.options = {
            prefix: options.prefix || 'form',
            emptyTemplateSelector: options.emptyTemplate || '#formsetItemTemplate',
            addMoreButton: options.addMoreButton || '.formsetAddMore button',
            appendBeforeSelector: options.insertBefore || '.formsetAddMore',
            deleteButtonSelector: options.deleteButtonSelector || '.formsetItemDelete',
            parentSelector: options.parentSelector || '.row:first',
            eventsHook: options.eventsHook || function (el) {}
        };

        // Reference to a form element
        this.$form = $(form);
        this.$addMoreButton = $(this.options.addMoreButton);
        this.emptyTemplate = $(this.options.emptyTemplateSelector).html();

        // Current number of forms
        this.$totalForms = this.$form.find('#id_' + this.options.prefix +'-TOTAL_FORMS');
        this.formCount = parseInt(this.$form.find('#id_' + this.options.prefix +'-TOTAL_FORMS').val());
        if (isNaN(this.formCount)) {
            console.warn('FormsetManager - Please check the the form prefix');
            this.formCount = 0;
        }

        // Events
        this._applyEvents(this.$form);
        
        this.$form.submit(function () {
            this.$totalForms.val(this.formCount);
        }.bind(this));

        this.$addMoreButton.click(function (e) {
            e.preventDefault();
            e.stopPropagation();
            this._addRow();
        }.bind(this));
    }

    FormsetManager.prototype = {
        _addRow: function () {
            var newRow = $(this.emptyTemplate.replace(/__prefix__/g, this.formCount++));
            newRow.insertBefore($(this.options.appendBeforeSelector));
            newRow.find('input:first').focus();
            this._applyEvents(newRow);
        },

        _deleteRow: function (deleteButton) {
            var deleteCheckbox = deleteButton.parents('div:first').find('input');
            deleteCheckbox.attr('checked', 'checked');
            deleteButton.parents(this.options.parentSelector).addClass('hidden');
        },

        _applyEvents: function (element) {
            element.find(this.options.deleteButtonSelector).click(function (e) {
                this._deleteRow($(e.target));
            }.bind(this));
            this.options.eventsHook(element);
        }
    };

    return FormsetManager;

}());